import React from "react";
import GridGallery from "../components/GridGallery";
import { motion } from "framer-motion";
import Contact from "../components/Contact";

export default function Gallery({ categories }) {
  return (
    <div
      className="min-h-screen bg-transparent text-slate-100 pt-32"
    >
      {/* --- Top navigation --- */}
      <div className="flex flex-wrap justify-center gap-4 mb-10 px-4">
        {Object.keys(categories).map((cat) => (
          <motion.a
            key={cat}
            href={`#${cat}`}
            whileHover={{ scale: 1.05 }}
            className="pill"
          >
            {cat}
          </motion.a>
        ))}
      </div>

      {/* --- Categories and images --- */}
      <div className="max-w-[1450px] mx-auto px-3 md:px-6">
        {Object.entries(categories).map(([cat, images], index) => (
          <section
            key={cat}
            id={cat}
            className={`mb-20 ${
              index !== 0 ? "border-t border-slate-700/70 pt-10" : ""
            }`}
          >
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-3xl font-semibold text-slate-100 mb-6 text-center"
            >
              {cat}
            </motion.h2>

            <GridGallery images={images} layout="collage" />
          </section>
        ))}
      </div>
      <Contact />

    </div>
  );
}
